import React from "react";
import "../styles/contactus.css";
import "../styles/cover.css";

export default class ContactUsForm extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            name: "",
            mobile: "",
            email: "",
            message: ""
        };

        this.onNameChange = this.onNameChange.bind(this);
        this.onMobileChange = this.onMobileChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.sendFeedback = this.sendFeedback.bind(this);
    }

    onNameChange = (event)=> {
        this.setState({name: event.target.value})
    };

    onMobileChange = (event)=> {
        this.setState({mobile: event.target.value})
    };

    onEmailChange = (event)=> {
        this.setState({email: event.target.value})
    };

    onMessageChange = (event)=> {
        this.setState({message: event.target.value})
    };

    sendEmail = () => {
        console.log("send email")
        const templateId = 'template_id';
        this.sendFeedback(templateId, {message: this.state.message, name: this.state.name, email: this.state.email,
            mobile: this.state.mobile})
    };

    sendFeedback = (templateId, variables) => {
        window.emailjs.send(
            'gmail', templateId,
            variables
        ).then(res => {
            console.log('Email successfully sent!')
        })
        // Handle errors here however you like, or use a React error boundary
            .catch(err => console.error('Oh well, you failed. Here some thoughts on the error that occured:', err))

    }

    render() {
        return (
            <div className="form-container">
                <div className="row padding-bottom-my">
                    <div className="col-sm-12 col-md-2 col-lg-2">
                        <span>Name </span>
                    </div>
                    <div className="col-sm-12 col-md-3 col-lg-3">
                        <input className="form-control" onChange={this.onNameChange}/>
                    </div>
                    <div className="col-sm-12 col-md-1 col-lg-1">
                        <span>Email</span>
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4">
                        <input className="form-control" onChange={this.onEmailChange}/>
                    </div>
                </div>
                <div className="row padding-bottom-my">
                    <div className="col-sm-12 col-md-2 col-lg-2">
                        <span>Mobile </span>
                    </div>
                    <div className="col-sm-12 col-md-8 col-lg-8">
                        <input className="form-control" onChange={this.onMobileChange}/>
                    </div>

                </div>
                <div className="row padding-bottom-my">
                    <div className="col-sm-12 col-md-2 col-lg-2">
                        <span>Message</span>
                    </div>
                    <div className="col-sm-12 col-md-8 col-lg-8">
                        <textarea className="form-control" onChange={this.onMessageChange}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-2 col-md-2 col-lg-2">
                    </div>
                    <div className="col-sm-12 col-md-8 col-lg-8">
                        <button className="btn btn-block button-my" onChange={this.sendEmail}>Send</button>
                    </div>
                </div>
            </div>
        )
    }
}